const configs = {
    backgroundColor: "#E0FFFF",
    neuronsCountRange: [2, 6],
    neuronDistanceBreakpoints: [50, 75, 110],
    electrifiedConnectionFramesCount: 4,
    info: "This is a game where all neurons should be connected to each other.When you connect all of them you will be taken to next collection or skip to the next challenge. Good luck!",
    infoImage:  "/synapseHash/info.png"
}

export default configs;